<div class="-dialog-header bank_detail" *ngIf="data.type == 1" [class.themeChanges]="data && data.send_data && data.send_data.themeChanges">
  
  <div class="d-flex card_bank" [class.mb-3]="data && data.send_data && !data.send_data.themeChanges">
    <div class="d-flex" *ngIf="data && data.send_data && !data.send_data.themeChanges">
      <!-- bank  -->
      <div (click)="existing(buttonSelectedType.bank)" *ngIf="data && data.send_data && data.send_data.bank_enable && data.send_data.bank_enable.currency && data.send_data.bank_enable.currency[0] && data.send_data.bank_enable.currency[0].bank_support_type">
        <button class="button-login-100 w-100 py-3"
          [ngClass]="[add_bank_step == 'bank' || payment_from==1 ? '' : ' color-gray bg_gray']">
          <span>
            <img src="assets/svg/bank.svg" alt="" srcset="">
            <span [ngClass]="[add_bank_step == 'bank' ? '' : 'color-gray']" class="vam">
              Bank
            </span>
            <!-- <img src="../../../../assets/svg/offer.svg" width="20px"
              tooltip="{{'If you instantly pay your payment today using bank, you will get ' + mainService.currency_data.display_logo + planInfo.plans_array[0].enrollment_fee + 'off on your contract enrollment fee!'}}"
              *ngIf="(opened_step == 1 || opened_step == 2) && planInfo.plans_array[0] && planInfo.enrollment_waiver == 1 && getNumber(planInfo.selected_payment_matrix.primary_type) == 3 && planInfo.enrollment_enabled == 0"> -->
          </span>
        </button>
      </div>
      <!-- card -->
      <div class="px-3 pt-sm-0" (click)="existing(buttonSelectedType.cardTab)">
        <button class="button-login-100 w-100 py-3" [ngClass]="[add_bank_step == 'card' ? '' : ' color-gray bg_gray']">
          <span>
            <img src="assets/svg/card.svg" alt="" srcset="">
            <span [ngClass]="[add_bank_step == 'card' ? '' : 'color-gray']" class="vam">
              Card
            </span>
          </span>
        </button>
      </div>
    </div>
    <div class="d-flex" *ngIf="data && data.send_data && data.send_data.themeChanges">
      <div class="card-selection col-12">
        <div class="col-12 text-start p-0" (click)="existing(buttonSelectedType.cardTab)">
          <input id="card" type="radio" name="banking" [checked]="add_bank_step == 'card'" class="pull-left d-none">
          <label for="card" class="fs-18" [ngClass]="add_bank_step == 'card'?'color-black-1': 'color-grey-5'">
            <span tappable>Add card</span>
          </label>
        </div>
  
        <div class="ms-3 col-md-6 text-start p-0" (click)="existing(buttonSelectedType.bank)" *ngIf="data?.send_data?.bank_enable?.currency?.[0]?.bank_support_type && ((data?.send_data?.selectedBusiness == 'HealthTechAcademy') || (data?.send_data?.selectedBusiness == 'WorkForceInstitute'))">
          <input id="bank" type="radio" name="banking" [checked]="add_bank_step == 'bank'" class="pull-left d-none">
          <label for="bank" class="fs-18" [ngClass]="padd_bank_step == 'bank' ? 'color-black-1': 'color-grey-5'">
            <span tappable>Add Bank</span>
          </label>
        </div>
      </div>
    </div>
    <button type="button" class="close" aria-label="Close" role="button_close" (click)="dialogRef.close()"><img
      src="assets/svg/close-circle.svg" alt=""></button>
  </div>
  <div mat-dialog-content *ngIf="add_bank_step == 'card'" class="p-0">
    <div class="card-selection" *ngIf="selectedCard && selectedCard.length > 0">
      <div class="col-md-6 text-start p-0"
        (click)="selected(1)">
        <input id="selected_optionOne" type="radio" name="selected_option" [(ngModel)]="selected_option" [value]="1"
          class="pull-left d-none">
        <label for="selected_optionOne" [ngClass]="payment_from == 3?'existing': 'new-existing'">
          <span tappable>Pay with existing
            card(s)</span>
        </label>
      </div>

      <div class="col-md-6 text-start p-0" (click)="selected(2)">
        <input id="selected_optionTwo" type="radio" name="selected_option" [(ngModel)]="selected_option" [value]="2"
          class="pull-left d-none">
        <label for="selected_optionTwo" [ngClass]="payment_from == 2?'existing': 'new-existing'">
          <span tappable>Pay with a new card</span>
        </label>
      </div>
    </div>
  </div>

  <!-- <div class="mb-3 col-12 col-md-12 p-md-0" *ngIf="payment_from==1">
    <button class="add_bank" *ngIf="!customer_details.bank_last4 || !bank_intent" (click)="checkCustomerBank(0)">Add
      Bank</button>
    <button class="add_bank" *ngIf="!bank_intent" (click)="checkCustomerBank(0)">Add
        Bank</button>
    <i class="fa fa-info-circle ms-2" placement="top" [tooltip]="'Click here for the list of supported banks'"
      (click)="resetBanks();searchBankModal.show()" *ngIf="!data.send_data['customer_details'].bank_last4"></i>
    <i class="fa fa-info-circle ms-2" placement="top" [tooltip]="'Click here for the list of supported banks'"
      (click)="resetBanks();searchBankModal.show()" *ngIf="!bank_intent"></i>
    <div
      *ngIf="data && data.send_data && data.send_data['customer_details'] && data.send_data['customer_details'].bank_last4"
      class="mt-3 mb-3">
      <div class="form-check" style="background: #FFFFFF;border-radius: 4px;padding:12px 23px;width:60%">
        <input class="form-check-input" type="radio" name="flexRadioDefault4" id="flexRadioDefault3" [(ngModel)]="binding">
        <label class="form-check-label" for="flexRadioDefault3"> <img src="assets\svg\bank.svg" alt="" class="ms-3">
          <span class="ms-2" style="color: #202020;font-size: 16px;">XXXX-XXXX-{{data && data.send_data &&
            data.send_data['customer_details'].bank_last4}}</span></label>
      </div>
    </div>
    <div id="payment-element"></div>
  </div> -->

  <div *ngIf="payment_from==2 || payment_from==1">
    <div class="bank_detail_filter" *ngIf="(selectedBank && selectedBank.length > 0) && payment_from == 1">
      <label class="custom-radio-box position-relative custom-radio-checkobx">
        <div>
          <img src="assets/svg/bank.svg" alt="" class="ms-3" />
          <span class="ms-2" style="color: #202020;font-size: 16px;">XXXX-XXXX-{{selectedBank && selectedBank[0] &&
            selectedBank[0].last4}}</span>
        </div>
        <div>
          <input type="radio" [value]="selectedBank[0]" class="ms-3" name="selected_card" [(ngModel)]="selected_card"
            [checked]="selectedBank && selectedBank[0] && selectedBank[0].source_id"  (change)="getSelectedCard(selected_card)"/>
          <label class="radio-label"></label>
        </div>
      </label>
    </div>
    <div class="mt-3 col-12 col-md-12 p-0" *ngIf="(payment_from==1 && (!selectedBank || (selectedBank && !selectedBank.length))) || payment_from==2">
      <div class="finance-panel" *ngIf="!showAddBankBtn">
        <app-generate-stripe-token [address]="{}" [buttonClickedSubject]="buttonClickedSubject"
          [elementId]="'iframe_add_card'" [show_authorization_text]="0" (cardResponse)="StripeTokenCreated($event)"
          class="col-12 my-col ps-0 pe-4" [show_save_card]="false" [show_address]="false" [show_only_cvv]="false"
          [payment_method_type]="payment_method_type" [payment_methods]="data.send_data?.payment" [themeChanges]="data.send_data?.themeChanges" [web_connect]="true"
          [backUp_Card]="false" [bankType]="add_bank_step == 'bank' ? 1 : 2">
        </app-generate-stripe-token>
        <!-- <div id="payment-element"></div> -->
      </div>
      <div class="finance-panel" *ngIf="showAddBankBtn">
        <button button-primary-auth class="px-5 w-100 mt-3" (click)="createPaymentIntent()">{{data && data.send_data && data.send_data.themeChanges ? 'Continue' : 'Add Bank'}}</button>
      </div>
    </div>
  </div>


  <div class="mb-3 col-12 col-md-12 p-0" *ngIf="payment_from==3">
    <div *ngIf="data && data.send_data && data.send_data['customer_details'].card_last4" class="mt-3 mb-3">
      <div class="form-check"
        style="background: #FFFFFF;border-radius: 40px;padding:12px 23px;width:60%;border: 1px solid;">
        <label class="form-check-label" for="flexRadioDefault3"> <img src="assets/svg/card.svg" alt="" class="ms-3">
          <span class="ms-2" style="color: #202020;font-size: 16px;">XXXX-XXXX-{{data && data.send_data &&
            data.send_data['customer_details'].card_last4}}</span></label>
      </div>
    </div>
    <div class="mt-3 col-12 col-md-11 p-0 stripe-finance">
      <div class="finance-panel finance-cvc" *ngIf="!showAddBankBtn">
        <app-generate-stripe-token [address]="{}" [buttonClickedSubject]="buttonClickedSubject"
          [elementId]="'iframe_cvc_card'" [show_authorization_text]="0" (cardResponse)="StripeTokenCreated($event)"
          class="col-12 my-col ps-0 pe-4" [show_save_card]="false" [show_address]="false" [show_only_cvv]="true"
          [payment_methods]="data.send_data['payment']" [web_connect]="true" [themeChanges]="data.send_data?.themeChanges" [backUp_Card]="false">
        </app-generate-stripe-token>
      </div>

      <div class="finance-panel finance-cvc" *ngIf="showAddBankBtn">
        <button button-primary-auth class="px-5 w-100 mt-3" (click)="createPaymentIntent()">{{data && data.send_data && data.send_data.themeChanges ? 'Continue' : 'Add Bank'}}</button>
      </div>
    </div>
  </div>
  <div *ngIf="(payment_from==1 && (selectedBank && selectedBank.length !== 0)) || payment_from == 3" class="add-card">
    <button button-primary-auth class="px-5 w-100 mt-md-3" (click)="confirmPayment()"><span id="add_now">{{data && data.send_data && data.send_data.themeChanges ? 'Continue' : 'Add Now'}}</span></button>
  </div>
</div>

<div bsModal #verifyModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-md  modal-dialog-centered customModal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Verify your account</h4>
        <button type="button" class="close" aria-label="Close" (click)="verifyModal.hide()">&times;</button>
      </div>
      <!-- <label>To use a different bank account, please <a href="javascript:void(0)" (click)="openCallbackModal()">contact us here</a>.</label> -->
      <!-- <div class="modal-body" *ngIf="customer_details && customer_details.bank_added">
        <label>Seems like you’ve previously paid using this bank account. To use this account again, please verify the
          last four digits of your <b>{{customer_details.bank_name}}</b> account.</label>
        <div class="row form-group">
          <div class="col-12 col-sm-10 input-group pt-1">
            <input type="text" class="form-control" name="last4_digits" [(ngModel)]="last4_digits"
              placeholder="Last 4 digits of your added bank" maxlength="4" required>
          </div>
        </div>
        <div class="text-center form-group">
          <button class="btn btn-primary mt-3 add_bank" (click)="verifyBankDetails();">Verify</button>
        </div>
      </div> -->
    </div>
  </div>
</div>

<div bsModal #searchBankModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md  modal-dialog-centered customModal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Supported Banks</h4>
        <button type="button" class="close" aria-label="Close" (click)="searchBankModal.hide()">&times;</button>
      </div>
      <div class="modal-body">
        <div class="row form-group">
          <div class="col-10 input-group pt-1">
            <input type="text" class="form-control" placeholder="Click here to search" name="bank_search"
              [(ngModel)]="bank_search" required (keydown.enter)="searchBankData(bank_search)">
            <div class="input-group-append" tappable (click)="resetBanks()">
              <span class="input-group-text">x</span>
            </div>
          </div>
          <div class="col-2 my-auto p-0">
            <a (click)="searchBankData(bank_search)" href="javascript:void(0)">Search</a>
          </div>
        </div>
        <div class="form-group" *ngIf="supported_banks && supported_banks.length > 0">
          <ul>
            <li *ngFor="let bank of supported_banks">{{bank.name}}</li>
          </ul>
        </div>
        <div class="form-group ms-4" *ngIf="!(supported_banks && supported_banks.length > 0)">
          No bank found
        </div>
      </div>
    </div>
  </div>
</div>